import {createTheme} from '@mantine/core';

export const theme = createTheme({
    fontFamily: 'indivisible, Arial, Helvetica Neue, Helvetica, San Francisco, sans-serif',
    // ... other theme override properties
});
